<template>
    <div>
    <div>
        <el-dropdown split-button>
        {{ selectedDashboard.tenant }} - 
        {{ selectedDashboard.title }}
        <template #dropdown>
            <el-dropdown-menu>
            <el-dropdown-item v-for="dash in listDashboard" :key="dash.id" @click="setURL(dash)"> {{ dash.tenant }} - {{ dash.title }}</el-dropdown-item>
            </el-dropdown-menu>
        </template>
        </el-dropdown>
    </div>
      <iframe  :src="url" ></iframe>
  </div>
  
</template>

<script>
import axios from 'axios'

export default {
    name: 'MainMenu',
    data() {
        return {
            url:"",
            listDashboard:[],
            selectedDashboard:{}
        }
    },
    mounted() {
        this.getURL()
        this.fetchData()
    },
    methods: {
        setURL(dash){
            this.selectedDashboard = dash
            if(dash.url){
                this.url = dash.url
            }else{
                this.url = "https://boardsiputra.bandungkab.go.id/app/dashboards?security_tenant="+dash.tenant+"#/view/"+dash.dashboard_id+"?embed=true&_g=(filters%3A!()%2CrefreshInterval%3A(pause%3A!t%2Cvalue%3A0)%2Ctime%3A(from%3Anow-1y%2Cto%3Anow))&show-query-input=true&show-time-filter=true"
            }
        },
        getURL(){
            if(this.$route.params.id){
                let id = this.$route.params.id
                this.url = "https://boardsiputra.bandungkab.go.id/app/dashboards#/view/"+id+"?embed=true&_g=(filters%3A!()%2CrefreshInterval%3A(pause%3A!t%2Cvalue%3A0)%2Ctime%3A(from%3Anow-1y%2Cto%3Anow))&show-query-input=true&show-time-filter=true"
            }
        },
        fetchData() {
            try {
                const params = {
                    limit: 100,
                    table_name: 'rec_dashboards'
                }
                axios.get(this.$store.state.base_url + "/api/data",
                    {
                        params,
                        headers: {
                            'Authorization': `Bearer ${this.$store.state.auth_token}`
                        }
                    }).then(response => {
                        this.listDashboard = response.data.data;
                        this.setURL(this.listDashboard[0])
                    })
                    .catch(error => {
                        console.error('There was an error!', error);
                    })


            } catch (error) {
                console.error('Terjadi kesalahan saat mengambil data:', error);
            }
        },
    }
}
</script>

<style>
iframe{
  border: none;
  width: 100%;
  height: 700px;
}
</style>
